import { defaults, entities, getAPIMethod } from 'typed/api';
import { ExtractAction, action, entityActionSet, networkAction } from './utils';

// TODO Merge rest of the actions/integrations to here

export const
    erpFinancialCalculationErrors = entityActionSet(defaults.ERPFinancialCalculationError, {
        loadAll: networkAction('LOAD_ALL_ERP_FINANCIAL_CALCULATION_ERRORS', getAPIMethod('ERPFinancialCalculationError', 'loadAll')),
        voidAll: action('VOID_ALL_ERP_FINANCIAL_CALCULATION_ERRORS')
    }),

    { loadAll: loadAllERPNetvisorIntegrationLockPeriods } = entityActionSet(defaults.ERPNetvisorIntegrationLockPeriod, {
        loadAll: networkAction('LOAD_ALL_ERP_NETVISOR_INTEGRATION_LOCK_PERIODS', getAPIMethod('ERPNetvisorIntegrationLockPeriod', 'loadAll'))
    }),

    calculateFinancialData = (startDate: Date) =>
        networkAction('CALCULATE_FINANCIAL_DATA', { startDate }, getAPIMethod('AccountingData', 'calculateFinancialData'), startDate),

    { loadAll: loadAllPowerBITokens } = entityActionSet(defaults.PowerBIToken, {
        loadAll: networkAction('LOAD_ALL_POWER_BI_TOKENS', getAPIMethod('PowerBIToken', 'loadAll'))
    }),

    loadAllPowerBIWorkspaces = () =>
        networkAction('LOAD_ALL_POWER_BI_WORKSPACES', getAPIMethod<entities.PowerBIWorkspace[]>('PowerBIToken', 'loadAllWorkspaces'));

export type IntegrationsAction = ExtractAction<
| typeof erpFinancialCalculationErrors
| typeof loadAllERPNetvisorIntegrationLockPeriods
| typeof calculateFinancialData
| typeof loadAllPowerBITokens
| typeof loadAllPowerBIWorkspaces
>;
